import { AxiosInstance } from './axios.core';

import { API_URL } from './api.base';
import { CancelToken, AxiosRequestConfig } from 'axios';

import { ListResponseModel, ListRuquestModel, OrganizationNodepProps, DeviceResponseModel } from './models'

export const getAllMacScriptList = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/mac/scripts/all`);
}

export const deleteCommandPolicyCustomScript = (policyId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/mac/settings/policies/${policyId}/customscripts`);
}

export const addCommandPolicyCustomScript = (policyId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/mac/settings/policies/${policyId}/customscripts`, { ...params });
}

export const getCommandPolicyCustomScript = (policyId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/mac/settings/policies/${policyId}/customscripts`);
}

export const deleteCommandPolicyLocalAccount = (policyId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/mac/settings/policies/${policyId}/localAccounts`);
}

export const addCommandPolicyLocalAccount = (policyId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/mac/settings/policies/${policyId}/localAccounts`, { ...params });
}

export const getCommandPolicyLocalAccount = (policyId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/mac/settings/policies/${policyId}/localAccounts`);
}

export const getLocalApp = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/mac/localapps/${id}`);
}

export const deleteLocalApp = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/mac/localapps/${id}`);
}

export const getLocalAppList = (params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/mac/localapps`, { params });
}

export const addDeviceForLocalApp = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/mac/localapps/${templateId}/devices`, { ...params });
}
export const getDeviceForLocalApp = (templateId: string, params: any, TagValueIds: string[]): Promise<ListResponseModel<any>> => {
  var tags = "";
  TagValueIds?.forEach((tag: string, index: number) => {
    if (index != 0) {
      tags += "&"
    }
    tags = tags + "tagValueIds=" + tag
  });
  return AxiosInstance.get(`${API_URL}/mac/localapps/${templateId}/devices?` + tags, { params });
}
export const getUnSelectedLocalAppDevices = (templateId: string, params: any): Promise<any[]> => {
  return AxiosInstance.get(`${API_URL}/mac/localapps/${templateId}/devices/unselected`, { params });
}
export const deleteDeviceForLocalApp = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/mac/localapps/${templateId}/devices`, { params });
}

export const getLocalAppScopes = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/mac/localapps/${templateId}/scopes`);
}

export const resetLocalAppScopes = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/mac/localapps/${templateId}/scopes`);
}

export const authLocalAppScopes = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/mac/localapps/${templateId}/scopes`, { ...params });
}

export const updateMacAppGetInfo = (_params: any, onUploadProgress: (progressEvent: any) => void): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }
  return AxiosInstance.put(
    `${API_URL}/mac/localapps/package`,
    params,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      onUploadProgress: onUploadProgress
    },
  );
};

export const addLocalApp = (_params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }
  return AxiosInstance.put(
    `${API_URL}/mac/localapps`,
    params,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
};

export const updateLocalApp = (id: string, _params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }
  return AxiosInstance.post(
    `${API_URL}/mac/localapps/${id}`,
    params,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
};

export const localAppResend = (localAppId: string, deviceId: string): Promise<string[]> => {
  return AxiosInstance.post(`${API_URL}/mac/localapps/${localAppId}/devices/${deviceId}/resend`);
}